export class AnimatorEngine {
    constructor() {
        this._animators = [];
        this._isPlaying = false;
        this._tick = (t) => {
            var _a;
            if (this._animators.length === 0) {
                this._cancelAnimation();
                return;
            }
            const animatorLength = this._animators.length;
            for (let i = 0; i < animatorLength; i++) {
                (_a = this._animators[i]) === null || _a === void 0 ? void 0 : _a.tick(t);
            }
            this._requestId = requestAnimationFrame(this._tick);
        };
    }
    registerAnimator_m(animator) {
        this._animators.push(animator);
    }
    unregisterAnimator_m(animator) {
        const index = this._animators.indexOf(animator);
        if (index !== -1) {
            this._animators.splice(index, 1);
        }
        if (this._animators.length === 0) {
            this.stop_m();
        }
    }
    start_m() {
        if (this._requestId || this._isPlaying) {
            return;
        }
        this._isPlaying = true;
        this._requestId = requestAnimationFrame(this._tick);
    }
    stop_m() {
        for (const animation of this._animators) {
            animation.pause();
        }
        this._cancelAnimation();
    }
    notifyAnimatorPaused_m() {
        const anyPlaying = this._animators.some(a => a.isPlaying);
        if (!anyPlaying) {
            this._cancelAnimation();
        }
    }
    _cancelAnimation() {
        this._isPlaying = false;
        if (this._requestId) {
            cancelAnimationFrame(this._requestId);
            this._requestId = undefined;
        }
    }
}
export const animatorEngine = new AnimatorEngine();
